import { createInteractiveColorVar } from '../../helpers/createInteractiveColorVar/index.js';

const ControlStartIconColors = createInteractiveColorVar('controls-start-icon');
const ControlStartIconColorsLightValues = Object.freeze({
    default: '#525252',
    action: '#3D3D3D',
    active: '#000000',
    activeAction: '#3D3D3D',
});
const ControlStartIconColorsDarkValues = Object.freeze({
    default: '#B3B3B3',
    action: '#CCCCCC',
    active: '#FFFFFF',
    activeAction: '#CCCCCC',
});

export { ControlStartIconColors, ControlStartIconColorsDarkValues, ControlStartIconColorsLightValues };
